// "Pedir análise à transportadora" na Auditoria CT-e (PO1-3391). Backend:
// backend_hub, módulo pedido-analise-cte. O embarcador do JWT manda; o
// `embarcadorId` do body só vale para admin sem claim (mesmo contrato do
// PUT /ctes/validar).
import api from "./api";

// Agrupa por transportadora, sugere destinatários e mostra o acesso. Não grava.
export async function previewPedidoAnalise({ embarcadorId, ids }) {
  const { data } = await api.post("/ctes/pedir-analise/preview", { embarcadorId, ids });
  return data;
}

// Envia um e-mail por transportadora. `destinatarios`: { [idTransportadora]: [emails] }.
export async function enviarPedidoAnalise({ embarcadorId, ids, mensagem, destinatarios }) {
  const { data } = await api.post("/ctes/pedir-analise", { embarcadorId, ids, mensagem, destinatarios });
  return data;
}

export const ROTULO_ACESSO = {
  portal: { texto: "Acessa o portal", tone: "success" },
  convite_novo: { texto: "Vai receber convite de acesso", tone: "info" },
  convite_reemitido: { texto: "Convite reenviado no e-mail", tone: "info" },
  curadoria: { texto: "Convite em curadoria: o e-mail vai sem link", tone: "warning" },
  convite_desabilitado: { texto: "Convite desligado: o e-mail vai sem link", tone: "warning" },
};

// Mensagem de erro no padrão do backend ({ error } ou { message }).
export function mensagemErro(err, fallback) {
  const d = (err && err.response && err.response.data) || {};
  if (d.error && typeof d.error === "object") return Object.values(d.error).join("; ");
  return d.error || d.message || (err && err.message) || fallback || "Erro inesperado";
}
